import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../../button/button.component';
import { HttpParams } from '@angular/common/http';
import { QueryParamsService } from '../../../../core/query-params.service';
import { ActivatedRoute } from '@angular/router';
import { CustomerFrontendManagementService } from '../../../../core/customer-frontend-management.service';

interface GroupFilterParams {
  page?: number | string;
  size?: number | string | null;
  customerId?: string[];
  name?: string;
  orderNumber?: string;
  userQuery?: string;
}

@Component({
  selector: 'app-group-filter',
  standalone: true,
  imports: [IconFieldModule, InputIconModule, InputTextModule, MultiSelectModule, FormsModule, ButtonComponent, CommonModule],
  templateUrl: './group-filter.component.html',
  styleUrl: './group-filter.component.scss',
})
export class GroupFilterComponent implements OnInit {
  @Output() filterListEvent = new EventEmitter<HttpParams>();

  name = '';
  orderTitle = '';
  userQuery = '';
  showClearButton = false;

  customerOptions: { label: string; value: string }[] = [];
  selectedCustomerIds: string[] = [];

  constructor(
    private queryService: QueryParamsService,
    private route: ActivatedRoute,
    private cfmService: CustomerFrontendManagementService
  ) {}

  ngOnInit(): void {
    this.loadFilterFromQueryParams();
    this.updateShowClearButton();
    this.loadCustomerOptions();
  }

  filterGroups(): void {
    const httpParams = this.queryService.createHttpParams({
      ...this.createFilterObject(),
      page: 0,
    });
    this.filterListEvent.emit(httpParams);
  }

  clearFilter(): void {
    this.name = '';
    this.orderTitle = '';
    this.userQuery = '';
    this.selectedCustomerIds = [];

    const filter = this.queryService.createHttpParams({
      page: 0,
      size: this.queryService.getCurrentQueryParams().get('size'),
    });
    this.filterListEvent.emit(filter);
    this.showClearButton = false;
  }

  onAnyChange(): void {
    this.updateShowClearButton();
  }

  private createFilterObject(): GroupFilterParams {
    const httpParams = this.queryService.getCurrentQueryParams();
    const filterParams: GroupFilterParams = {};

    const size = httpParams.get('size');
    if (size) filterParams.size = size;

    if (this.name) filterParams.name = this.name;
    if (this.orderTitle) filterParams.orderNumber = this.orderTitle;
    if (this.userQuery) filterParams.userQuery = this.userQuery;
    if (this.selectedCustomerIds.length > 0) filterParams.customerId = this.selectedCustomerIds;
    return filterParams;
  }

  private loadFilterFromQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      const httpParams = this.queryService.convertQueryParamsToHttpParams(params);
      this.name = httpParams.get('name') || '';
      this.orderTitle = httpParams.get('orderNumber') || '';
      this.userQuery = httpParams.get('userQuery') || '';
      const customerIdsRaw = httpParams.getAll('customerId') || [];
      this.selectedCustomerIds = customerIdsRaw.flatMap((s) => s.split(',').map((v) => v.trim())).filter((v) => !!v);
    });
  }

  private updateShowClearButton(): void {
    this.showClearButton = !!(
      this.name ||
      this.orderTitle ||
      this.userQuery ||
      (this.selectedCustomerIds && this.selectedCustomerIds.length)
    );
  }

  private loadCustomerOptions() {
    this.cfmService.getAllCustomers().subscribe({
      next: (customers) => {
        this.customerOptions = (customers || []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
      },
    });
  }
}
